'use client';

import { Button } from '@/components/ui/design-system';
import Link from 'next/link';

export function ExploreIndustriesButton() {
  return (
    <div className="text-center mt-12">
      <Button asChild variant="outline" size="lg">
        <Link href="/industries">
          Explore All Industries
        </Link>
      </Button>
    </div>
  );
}
